import { render, staticRenderFns } from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=template&id=23746be6&scoped=true&"
import script from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=script&lang=js&"
export * from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=script&lang=js&"
import style0 from "./RiskCheckDailySafetyChecklistDetail.vue?vue&type=style&index=0&id=23746be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23746be6",
  null
  
)

export default component.exports